import React from 'react'
import { Switch, BrowserRouter as Router, Route } from 'react-router-dom'

import NotFoundPage from './components/pages/NotFoundPage'
import DetectDevicePage from './components/pages/DetectDevicePage'
import PlaygroundPage from './components/pages/PlaygroundPage'
import ImageManagement from './components/pages/web/ImageManagementPage'
import ErrorPage from './components/pages/ErrorPage'
import GeneralInfoPage from './components/pages/web/GeneralInfoPage'
import ProtectedPortalRouteWithAuth from './components/templates/route-management/ProtectedPortalRouteWithAuth'
import ProtectedAuthRoute from './components/templates/route-management/ProtectedAuthRoute'
import SigninPage from './components/pages/web/SigninPage'
import PortalListPage from './components/pages/web/PortalListPage'
import PortalExportPage from './components/pages/web/PortalExportPage'
import MobileHomePage from './components/pages/mobile/MobileHomePage'
import MobileFormPage from './components/pages/mobile/MobileFormPage'
import TownListPage from './components/pages/web/TownListPage'
import ListingListPage from './components/pages/web/ListingListPage'
import BannerListPage from './components/pages/web/BannerListPage'
import ListingDetailPage from './components/pages/web/ListingDetailPage'
import ListingCreatePage from './components/pages/web/ListingCreatePage'
import MainMenu from './components/pages/web/MainMenu'
import ContributorListPage from './components/pages/web/ContributorListPage'
import ContributorFormPage from './components/pages/web/ContributorFormPage';

import * as ROLES from './constants/roles'
import WebAdminPage from './components/pages/web/WebAdminPage';

const AppRouter = () => (
  <Router>
    <div>
      <Switch>
        {/* <Route exact path="/" component={DetectDevicePage} />
     
      <Route path="/mobile/admin" component={MobileHomeAdminPage} />
      <Route path="/web/portal/:portalID" component={WebTransferInfoPage} />
      <Route path="/web/admin" component={WebHomeAdminPage} />
      <Route path="/web" component={WebHomePage} />
      <Route path="/image-management/" component={ImageManagement} /> */}

        <Route exact path="/" component={DetectDevicePage} />

        <ProtectedPortalRouteWithAuth
          path="/mobile/portal/:portalID"
          component={MobileFormPage}
          ifAnyGranted={[ROLES.SUPERVISOR, ROLES.PORTAL_CREATOR]}
        />
        <ProtectedAuthRoute
          path="/mobile"
          component={MobileHomePage}
          ifAnyGranted={[ROLES.SUPERVISOR, ROLES.PORTAL_CREATOR]}
        />

        <Route path="/login" component={SigninPage} />
        <Route path="/playground" component={PlaygroundPage} />

        <ProtectedAuthRoute
          path="/menu"
          component={MainMenu}
          ifAnyGranted={[ROLES.SUPERVISOR, ROLES.PORTAL_CREATOR]}
        />

        <ProtectedAuthRoute
          path="/towns/:townID/listings/create"
          component={ListingCreatePage}
          ifAnyGranted={[ROLES.SUPERVISOR]}
        />
        <ProtectedAuthRoute
          path="/towns/:townID/listings/:listingID"
          component={ListingDetailPage}
          ifAnyGranted={[ROLES.SUPERVISOR]}
        />

        <ProtectedAuthRoute
          path="/towns/:townID/listings"
          component={ListingListPage}
          ifAnyGranted={[ROLES.SUPERVISOR]}
        />
        <ProtectedAuthRoute
          path="/towns/:townID/banners"
          component={BannerListPage}
          ifAnyGranted={[ROLES.SUPERVISOR]}
        />
        <ProtectedAuthRoute
          path="/towns"
          component={TownListPage}
          ifAnyGranted={[ROLES.SUPERVISOR]}
        />
        
        <ProtectedAuthRoute
          path="/contributor/:contributorID"
          component={ContributorFormPage}
          ifAnyGranted={[ROLES.SUPERVISOR, ROLES.PORTAL_CREATOR]}
        />

        <ProtectedAuthRoute
          path="/contributor"
          component={ContributorListPage}
          ifAnyGranted={[ROLES.SUPERVISOR, ROLES.PORTAL_CREATOR]}
        />

        <ProtectedAuthRoute
          path="/portals"
          component={PortalListPage}
          ifAnyGranted={[ROLES.SUPERVISOR, ROLES.PORTAL_CREATOR]}
        />

        <ProtectedAuthRoute
          path="/web-admin"
          component={WebAdminPage}
          ifAnyGranted={[ROLES.SUPERVISOR]}
        />

        <ProtectedPortalRouteWithAuth
          path="/:portalID/image-management"
          component={ImageManagement}
          ifAnyGranted={[ROLES.SUPERVISOR, ROLES.PORTAL_CREATOR]}
        />

        <ProtectedPortalRouteWithAuth
          path="/:portalID/info"
          component={GeneralInfoPage}
          ifAnyGranted={[ROLES.SUPERVISOR, ROLES.PORTAL_CREATOR]}
        />

        <ProtectedPortalRouteWithAuth
          path="/:portalID/export"
          component={PortalExportPage}
          ifAnyGranted={[ROLES.SUPERVISOR, ROLES.PORTAL_CREATOR]}
        />

        <Route path="/error" component={ErrorPage} />
        <Route path="/" component={NotFoundPage} />
      </Switch>
    </div>
  </Router>
)
export default AppRouter



// WEBPACK FOOTER //
// ./src/AppRouter.js